import React, { useEffect, useState, useRef } from "react";
import { ButtonGroup, Grid, FormControlLabel, Switch, Button, Checkbox } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { useVideoSyncMonitor } from "../../api/VideoSyncMonitor";
import DesktopAccessDisabledIcon from '@mui/icons-material/DesktopAccessDisabled';

// import vidDiffSigns from "../../assets/videos/cameraTester/vidDiffSigns.mp4"
// import vidDiffOrder from "../../assets/videos/cameraTester/vidDiffOrder.mp4"
// import vidDiffNumberSigns from "../../assets/videos/cameraTester/vidDiffNumberSigns.mp4"

import vidDiffSigns from "../../assets/videos/cameraTester/reduced_vidDiffSigns.mp4"
import vidDiffOrder from "../../assets/videos/cameraTester/reduced_vidDiffOrder.mp4"
import vidDiffNumberSigns from "../../assets/videos/cameraTester/reduced_vidDiffNumberSigns.mp4"

import Tooltip from '@mui/material/Tooltip';
import Popper from '@material-ui/core/Popper';



export function IterativeFeedbackRecorderSentences(props) {
    const { action_send, action_discard } = props
    const [feedback, setFeedback] = useState({
        'isActivated': false,
        'isValid': null,
        'notEqualCases': {
            'diffSigns': false,
            'diffOrder': false,
            'diffNumberSigns': false,
        },
    });

    const [openTooltip, setOpenTooltip] = useState(false);


    const {
      isPlayingRecorder,
      isPlayingReference,
      setForceStartVideoRecorder,
      setForceStopVideoRecorder,
      setForceStartVideoReference,
      setForceStopVideoReference,
    } = useVideoSyncMonitor();

    const keysAndLabelsWhenEqual = [
      { key: 'equalOrder', label: 'Mismo orden' },
      { key: 'equalSigns', label: 'Mismos signos' },
      { key: 'equalNumberSigns', label: 'Mismo número de signos' },
    ];

    const keysAndLabelsWhenNotEqual = [
      { key: 'diffSigns', label: 'Signos diferentes', video: vidDiffSigns },
      { key: 'diffOrder', label: 'Orden diferente', video: vidDiffOrder },
      { key: 'diffNumberSigns', label: 'Nº signos diferente', video: vidDiffNumberSigns },
    ];

    useEffect(() => {
        console.log("🚀 ~ IterativeFeedbackRecorderSentences ~ feedback:", feedback)
    }, [feedback]);

    const handleCheckboxChange = (event) => {
        setFeedback(prevFeedback => ({
          ...prevFeedback,
          notEqualCases: {
            ...(prevFeedback.notEqualCases || {}),
            [event.target.name]: event.target.checked
          }
        }));
    };

    const handleIsValidButtons = (isValidValue) => {
        setFeedback(prevFeedback => ({
          ...prevFeedback,
          isValid: isValidValue,
          notEqualCases: {
            diffSigns: false,
            diffOrder: false,
            diffNumberSigns: false
          }
        }));
    }; 

    const handleStartVideoReference = () => {
      console.log("🚀 ~ handlePlayVideoReference ~ handleStartVideoReference:", handleStartVideoReference)
      setForceStartVideoReference(new Date().getTime())
    }

    const handleStopVideoReference = () => {
      console.log("🚀 ~ handlePlayVideoReference ~ handleStopVideoReference:", handleStopVideoReference)
      setForceStopVideoReference(new Date().getTime())
    }

    const handleStartVideoBoth = () => {
      console.log("🚀 ~ handlePlayVideoReference ~ handleStartVideoBoth:", handleStartVideoBoth)
      setForceStartVideoReference(new Date().getTime())
      setForceStartVideoRecorder(new Date().getTime())
    }

    const handleStopVideoBoth = () => {
      console.log("🚀 ~ handlePlayVideoReference ~ handleStopVideoBoth:", handleStopVideoBoth)
      setForceStopVideoReference(new Date().getTime())
      setForceStopVideoRecorder(new Date().getTime())
    }

    const handleStartVideoRecorded = () => {
      console.log("🚀 ~ handlePlayVideoReference ~ handleStartVideoRecorded:", handleStartVideoRecorded)
      setForceStartVideoRecorder(new Date().getTime())
    }

    const handleStopVideoRecorded = () => {
      console.log("🚀 ~ handlePlayVideoReference ~ handleStopVideoRecorded:", handleStopVideoRecorded)
      setForceStopVideoRecorder(new Date().getTime())
    }

    const handleSend = () => {
      console.log("🚀 ~ handleSend ~ handleSend:", handleSend)
      action_send(feedback)
    }
    

    const handleDiscard = () => {
      console.log("🚀 ~ handleSend ~ handleSend:", handleSend)
      action_discard(feedback)
    }
  
    return (
  
      <>
        <div style={{ width: '70%', position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', transform: 'scale(1)', margin: '0px auto'}}>
          <Button variant="outlined" 
            style={{ backgroundColor: isPlayingReference ? '#fd000063': '',  width: '80%', borderRadius: '5px', borderColor: '#5ea0d4', height: '40px', margin: '0 10px 0 10px' }} startIcon= {isPlayingReference ? <OndemandVideoIcon/>: <DesktopAccessDisabledIcon/>}  
            onClick={isPlayingReference ? handleStopVideoReference : handleStartVideoReference}> {isPlayingReference ? 'Detener': 'Ver'} referencia 
          </Button>

          <Button variant="outlined" 
            style={{ width: '80%', borderRadius: '5px', borderColor: '#5ea0d4', height: '40px', margin: '0 10px 0 10px' }} startIcon= {isPlayingReference ? <OndemandVideoIcon color="error"/>: <DesktopAccessDisabledIcon/>} endIcon= {isPlayingRecorder ? <OndemandVideoIcon color="error"/>: <DesktopAccessDisabledIcon/>}
            onClick={isPlayingReference && isPlayingRecorder ? handleStopVideoBoth : handleStartVideoBoth}> {isPlayingReference && isPlayingRecorder ? 'Detener': 'Ver'} ambos 
          </Button>

          <Button variant="outlined" 
            style={{ backgroundColor: isPlayingRecorder ? '#fd000063': '',  width: '80%', borderRadius: '5px', borderColor: '#5ea0d4', height: '40px', margin: '0 10px 0 10px' }} endIcon= {isPlayingRecorder ? <OndemandVideoIcon/>: <DesktopAccessDisabledIcon/>}
            onClick={isPlayingRecorder ? handleStopVideoRecorded : handleStartVideoRecorded}> {isPlayingRecorder ? 'Detener': 'Ver'} grabación 
          </Button>

        </div>

        <Paper style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', transform: 'scale(1)', margin: '0 auto', padding: '2px'}}>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', width: '90%', margin: '0 auto', borderRadius: '10px' }}>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #5ea0d4', margin: '1px', borderRadius: '10px', height: '100%' }}>
                    <Typography style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', color: "#127dd2", fontSize: '20px' }}>
                        ¿ La Frase es igual ?
                    </Typography>
                </div>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '2px solid #5ea0d4', margin: '1px', borderRadius: '10px', height: '100%' }}>
                    <Button variant="outlined" 
                        style={{ width: '80%',  backgroundColor: feedback.isValid == true ? 'green' : '#d5f7d5', color: feedback.isValid == true ? 'white': 'black', borderRadius: '5px', borderColor: 'red', height: '40px', margin: '2px' }} 
                        onClick={() => handleIsValidButtons(true)}>SI</Button>
                    <Button variant="outlined" 
                        style={{ width: '80%',  backgroundColor: feedback.isValid == false ? 'red' : '#f7e7e7', color: feedback.isValid == false ? 'white': 'black', borderRadius: '5px', borderColor: 'red', height: '40px', margin: '2px' }}
                        onClick={() => handleIsValidButtons(false)} >NO</Button>
                </div>

                {feedback['isValid'] !== null && (
                  <div style={{ backgroundColor: feedback.isValid ? "#d5f7d5" : "#f7e7e7", flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', border: '2px solid #5ea0d4', margin: '1px', borderRadius: '10px', height: '100%' }}>
                    
                    {(feedback.isValid ? keysAndLabelsWhenEqual : keysAndLabelsWhenNotEqual).map(({ key, label, video }) => (
                      <label style={{ margin: '-5px', marginLeft: '40px' }} key={key}>
                        
                          <Checkbox
                            checked={ feedback.isValid ? true : feedback.notEqualCases?.[key]}
                            disabled={feedback.isValid}
                            onChange={handleCheckboxChange}
                            name={key}
                          />
                          {label}
                          { video!==undefined &&
                            <Tooltip
                            title={<video src={video} loop controls autoPlay muted style={{ width: '600px' }} />}
                            PopperProps={{
                              popperOptions: {
                                modifiers: {
                                  flip: {
                                    enabled: false,
                                  },
                                  preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'window',
                                  },
                                  computeStyle: {
                                    gpuAcceleration: false,
                                  },
                                },
                              },
                              anchorEl: { clientHeight: 0, clientWidth: 0 },
                              style: { position: 'absolute', left: `${window.innerWidth - 620}px`, top: '0%'},
                            }}
                            interactive
                          >
                          
                            <strong 
                              style={{color: "blue"}} 
                              onClick={(event)=>{
                                event.preventDefault();
                                setOpenTooltip(!openTooltip);
                              }}
                            >  
                              {" [ Ejemplo ]" }
                            </strong>
                          </Tooltip>
                        }
                      </label>
                    ))}
                  </div>
                )}

          { (feedback['isValid'] === true || Object.values(feedback['notEqualCases']).some(value => value === true)) && (

              <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #5ea0d4', margin: '1px', borderRadius: '10px', height: '100%' }}>
                <Button 
                  onClick={feedback.isValid ? handleSend : handleDiscard} 
                  style={{ width: '100%', height: '100%' }}
                >
                  {feedback.isValid ? 'Enviar' : 'Volver a grabar'}
                </Button>
              </div>
                )}
            </div>
        </Paper>
        
      </>          
              
      );
    }